<div class="dam-element">
  <label *ngIf="write" i18n="@@ClickOrDragDocument" for="document-uploader-input" class="well my-drop-zone" ng2FileDrop [ngClass]="{'file-over': true}" (onFileDrop)="upload()" [uploader]="uploader"> Кликните или перетащите сюда версию документа </label> <input type="file" ng2FileSelect (change)="upload()" [uploader]="uploader" multiple id="document-uploader-input" style="display:none"/>

  <div class="section" *ngIf="damItem">
    <a (click)="show(actions, damItem.id)" target="_blank">
      <app-secured-image *ngIf="damService.showThumbnail(damItem?.mimeType)" src="/dam/get-image-dynamic-version/{{damItem.id}}/800/true"/>
      <img *ngIf="!damService.showThumbnail(damItem?.mimeType)" style="height: 100px;" class="vivid" src="/assets/images/vivid/{{damService.getExtension(damItem)}}.svg" alt="">
    </a>

    <h6>{{ damItem?.header }} </h6>

    <div>
      ID {{ damItem?.documentId }}
    </div>
    <div>
      <span i18n="@@Updated">Изменено</span>: {{ (damItem?.updatedAt || damItem?.createdAt) | date: 'dd.MM.yyyy hh:mm' }}
    </div>
    <!--      <span class="clr-black-sec fw-500 fs-12">-->
    <!--        <span i18n="@@Approved">Подтверждено</span>: {{damItem?.documentId}}-->
    <!--			</span>-->
  </div>
</div>

<ng-template #actions let-content="content">
  <a download size="small" nbButton [href]="content" i18n="@@Download"> Скачать </a>
</ng-template>

